module.exports = __webpack_public_path__ + "img/UserIcons.0c7f1be2.svg";